import { useTranslation } from "react-i18next"

import { AeronLogo } from "@/components/logos/AeronLogo"
import { AERON_URL } from "@/constants"

export const Aeron = () => {
  const { t } = useTranslation()
  return (
    <div
      className="mr-auto flex cursor-pointer items-start gap-xs"
      onClick={() => window.open(AERON_URL)}
    >
      <p className="text-xs-regular text-quaternary">{t("powered")}</p>
      {<AeronLogo className="text-primary" />}
    </div>
  )
}
